import {BrandingObject} from '../../server/functions/login/login.types.js'

declare global {
    interface Window {
        opera?: any
        MSStream?: any
    }
}

function getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
    }

    if (/android/i.test(userAgent)) {
        return 'Android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
    }

    return 'unknown'
}

// Opens the given article in the knowledge base, unless the reseller set its own messenger manual
function onClickHelp(article = 'inloggen-en-app-installeren', branding?: BrandingObject) {
    if (branding?.manualURLMessenger) {
        window.open(branding.manualURLMessenger, '_blank')
        return
    }

    window.open(`https://handleiding.veloyd.nl/docs/${article}/`, '_blank')
}

// Whether a messenger can handle an address that is not the next stop right away, only after a warning, or not at all
function nextStopDeviation(reseller: {settings: {nextStopWarning?: string, nextStopShowWarning?: boolean}}, address: {isNextStop?: boolean, skipsFixedZone?: boolean}): 'allowed' | 'warning' | 'notallowed' {
    if (address.isNextStop) {
        return 'allowed'
    }

    const {nextStopWarning, nextStopShowWarning} = reseller.settings

    if (nextStopWarning === 'notallowed' || (nextStopWarning === 'notallowedanchored' && address.skipsFixedZone)) {
        return 'notallowed'
    }

    return nextStopShowWarning ? 'warning' : 'allowed'
}

// Address text for a navigation app link, the postal code helps the app to find the right address
function navigationDestination(address: {street: string, nr: string, addition?: string, postalCode?: string, city: string}, {dropLongAddition = false} = {}) {
    let addition = address.addition || ''

    // Google Maps sometimes can't find an address with a longer addition
    if (dropLongAddition && addition.length > 1) {
        addition = ''
    }

    const postalCodeCity = [address.postalCode, address.city].filter(Boolean).join(' ')

    return encodeURIComponent(`${address.street} ${address.nr}${addition}, ${postalCodeCity}`)
}

export default {
    getMobileOperatingSystem,
    onClickHelp,
    nextStopDeviation,
    navigationDestination
}
